import { useState } from "react";

import { Button, PopOut, PopOutStyleInterface } from "@newsela/angelou";
import PropTypes from "prop-types";

import ClickableRow from "@/components/ClickableRow";
import RawEditIcon from "../../../icons/EditIcon/RawEditIcon.svg.jsx";
import {
  editContainerCss,
  editIconCss,
  editMenuCss,
  editStepCss,
  editStepPopoutCss,
  editStepPopoutRowCss,
} from "./EditStepButton.style";

const { PopOutPosition } = PopOutStyleInterface;
const propTypes = {
  /**
   * Function to trigger to show add activity modal
   */
  onAddActivity: PropTypes.func,
  /**
   * Function to trigger to delete a step
   */
  onDeleteStep: PropTypes.func,
  /**
   * Function to trigger to move a step up
   */
  onMoveStepUp: PropTypes.func,
  /**
   * Function to trigger to move a step down
   */
  onMoveStepDown: PropTypes.func,
  /**
   * Indicates if DeleteStep button is visible in Popout
   */
  isVisibleDeleteStep: PropTypes.bool,
  /**
   * Indicates if Move Up button is visible in Popout
   */
  isVisibleMoveUp: PropTypes.bool,
  /**
   * Indicates if Move Down button is visible in Popout
   */
  isVisibleMoveDown: PropTypes.bool,
};

const EditStepButton = (props) => {
  const {
    onAddActivity,
    onDeleteStep,
    onMoveStepUp,
    onMoveStepDown,
    isVisibleDeleteStep,
    isVisibleMoveUp,
    isVisibleMoveDown,
  } = props;
  const [isPopOutVisible, setIsPopOutVisible] = useState(false);

  const togglePopOutVisibility = () => {
    setIsPopOutVisible(!isPopOutVisible);
  };

  return (
    <div css={editContainerCss}>
      <Button
        onClick={togglePopOutVisibility}
        icon={{
          SvgComponent: RawEditIcon,
          alignment: Button.iconAlignments.left,
        }}
        size={Button.sizes.md}
        flavor={Button.flavors.secondary}
        id="EditStep"
        __cssFor={{ Icon: { root: editIconCss } }}
      >
        Edit Step
      </Button>
      <PopOut
        __cssFor={{
          root: editStepPopoutCss,
        }}
        ariaProps={{ "aria-labelledby": "EditStep" }}
        isVisible={isPopOutVisible}
        onClickOff={togglePopOutVisibility}
        onEsc={togglePopOutVisibility}
        verticalOffset="10px"
        horizontalPosition={PopOutPosition.right}
      >
        <div style={editStepCss}>
          <ul css={editMenuCss}>
            <li>
              <ClickableRow
                onClick={() => {
                  togglePopOutVisibility();
                  onAddActivity();
                }}
                css={editStepPopoutRowCss}
              >
                Add Activity
              </ClickableRow>
            </li>
            {isVisibleMoveUp && (
              <li>
                <ClickableRow
                  onClick={() => {
                    togglePopOutVisibility();
                    onMoveStepUp();
                  }}
                  css={editStepPopoutRowCss}
                >
                  Move up
                </ClickableRow>
              </li>
            )}
            {isVisibleMoveDown && (
              <li>
                <ClickableRow
                  onClick={() => {
                    togglePopOutVisibility();
                    onMoveStepDown();
                  }}
                  css={editStepPopoutRowCss}
                >
                  Move down
                </ClickableRow>
              </li>
            )}
            {isVisibleDeleteStep && (
              <li>
                <ClickableRow
                  onClick={(e) => {
                    togglePopOutVisibility();
                    onDeleteStep(e);
                  }}
                  css={editStepPopoutRowCss}
                >
                  Delete step
                </ClickableRow>
              </li>
            )}
          </ul>
        </div>
      </PopOut>
    </div>
  );
};

EditStepButton.propTypes = propTypes;
export default EditStepButton;
